import { ErrorBoundary as SentryBoundary, type ErrorBoundaryProps } from '@sentry/nextjs';

const ErrorBoundary = ({ children, ...otherProps }: ErrorBoundaryProps) => (
  <SentryBoundary {...otherProps}>{children}</SentryBoundary>
);

export default ErrorBoundary;
